export class Deputy {
    id?:number;
    empId?:any;
    substituteId?:any;
    startDate?:any;
    endDate?:any;
}
  
